import { ColumnType, TransferUserInfoType } from '../types';

export const columns = (data: TransferUserInfoType): ColumnType[] => [
  {
    title: '회원번호',
    value: data.id,
  },
  {
    title: '계정 상태',
    value: data.status,
    active: true,
  },
  {
    title: '이름',
    value: data.name,
  },
  {
    title: '유저 계정',
    value: data.account,
    active: true,
  },
  {
    title: '로그인 타입',
    value: data.loginType,
  },
  {
    title: '핸드폰',
    value: data.cellPhone,
  },
  {
    title: '가입일자',
    value: data.createDate,
  },
];
